"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCloudToDevice = exports.create = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const device_1 = require("../../device");
const Prefs = __importStar(require("./prefs"));
exports.NAMESPACE = 'Culligan.Protocol.Common.Payload';
const create = (version, Device, message, encodedAnnotations = {}) => {
    const VendorCode = effect_1.Schema.Literal(...Device.vendors).annotations({
        identifier: `${exports.NAMESPACE}.VendorCode<"${Device.code}">`,
    });
    const DEC = (0, device_1.createCodeParser)(Device).annotations({
        identifier: `${exports.NAMESPACE}.DEC<"${Device.code}">`,
        description: 'The DEC is an identifier that starts with the vendor code, ' +
            'followed by the device code, optionally followed by an environment identifier',
    });
    const MessageHeader = effect_1.Schema.Struct({ dEC: DEC, pVer: effect_1.Schema.tag(version) }).annotations({
        identifier: `${exports.NAMESPACE}.MessageHeader<${version}, "${Device.code}">`,
        description: 'The header of the message containing the version and device ID',
    });
    const EncodedPayload = effect_1.Schema.Struct({
        id: MessageHeader,
        msgs: effect_1.Schema.NonEmptyArray(message),
    }).annotations({
        identifier: `${exports.NAMESPACE}.EncodedPayload<"${Device.code}">`,
        ...encodedAnnotations,
    });
    const Payload = effect_1.Schema.Struct({
        deviceModel: effect_1.Schema.tag(Device.code),
        deviceVendor: VendorCode,
        protocolVersion: effect_1.Schema.tag(version),
        messages: effect_1.Schema.NonEmptyArray(message),
    }).annotations({
        identifier: `${exports.NAMESPACE}.Payload<"${Device.code}">`,
    });
    return effect_1.Schema.transform(EncodedPayload, effect_1.Schema.typeSchema(Payload), {
        strict: false, // TypeScript doesn't understand transform of parameterized type.
        decode: ({ id: { dEC: [deviceVendor, deviceModel], pVer: protocolVersion, }, msgs: messages, }) => ({ deviceModel, deviceVendor, protocolVersion, messages }),
        encode: ({ deviceModel, deviceVendor, protocolVersion, messages }) => ({
            id: {
                dEC: [deviceVendor, deviceModel, ''],
                pVer: protocolVersion,
            },
            msgs: messages,
        }),
    });
};
exports.create = create;
/**
 * Creates a protocol V2 C2D codec that preserves canonical envelopes for API
 * input while encoding a single preferences message as a device command.
 */
const createCloudToDevice = (version, Device, message, preferences, encodedAnnotations = {}) => {
    const CanonicalPayload = (0, exports.create)(version, Device, message, encodedAnnotations);
    const PartialEncodedPreferences = Prefs.createPartialEncoded(preferences);
    const PreferencesCommand = effect_1.Schema.Union(effect_1.Schema.Struct({
        pVer: effect_1.Schema.Literal(version),
        channel: effect_1.Schema.Literal('command'),
        command: effect_1.Schema.Literal('prefs.get'),
    }), effect_1.Schema.Struct({
        pVer: effect_1.Schema.Literal(version),
        channel: effect_1.Schema.Literal('command'),
        command: effect_1.Schema.Literal('prefs.set'),
        params: PartialEncodedPreferences,
    })).annotations({
        identifier: `${exports.NAMESPACE}.PreferencesCommand<"${Device.code}">`,
    });
    const decodePreferencesCommand = effect_1.Match.type().pipe(effect_1.Match.discriminatorsExhaustive('command')({
        'prefs.get': () => ({
            channel: 'prefs',
            _tag: 'Get',
        }),
        'prefs.set': ({ params }) => ({
            channel: 'prefs',
            _tag: 'Patch',
            prefs: params,
        }),
    }));
    const encodePreferencesMessage = effect_1.Match.typeTags()({
        Get: () => ({
            pVer: version,
            channel: 'command',
            command: 'prefs.get',
        }),
        Patch: ({ prefs }) => ({
            pVer: version,
            channel: 'command',
            command: 'prefs.set',
            params: prefs,
        }),
    });
    const SinglePreferencesPayload = effect_1.Schema.typeSchema(CanonicalPayload).pipe(effect_1.Schema.filter(({ messages }) => messages.length === 1 && messages[0].channel === 'prefs'));
    const FlatPreferencesPayload = effect_1.Schema.transformOrFail(PreferencesCommand, SinglePreferencesPayload, {
        strict: false,
        decode: (wirePayload, _, ast) => {
            const [deviceVendor] = Device.vendors;
            if (deviceVendor === undefined) {
                return effect_1.ParseResult.fail(new effect_1.ParseResult.Forbidden(ast, wirePayload, 'Cannot decode a preferences command without a device vendor'));
            }
            return effect_1.Schema.decode(message)(decodePreferencesCommand(wirePayload)).pipe(effect_1.Effect.map(decodedMessage => ({
                deviceModel: Device.code,
                deviceVendor,
                protocolVersion: version,
                messages: [decodedMessage],
            })), effect_1.Effect.mapError(error => error.issue));
        },
        encode: (payload, _, ast) => effect_1.Schema.encode(CanonicalPayload)(payload).pipe(effect_1.Effect.mapError(error => error.issue), effect_1.Effect.flatMap(({ msgs }) => {
            if (msgs.length !== 1 || msgs[0].channel !== 'prefs') {
                return effect_1.ParseResult.fail(new effect_1.ParseResult.Forbidden(ast, payload, 'Only a single preferences message can use the command wire format'));
            }
            return effect_1.ParseResult.succeed(encodePreferencesMessage(msgs[0]));
        })),
    });
    return effect_1.Schema.Union(FlatPreferencesPayload, CanonicalPayload);
};
exports.createCloudToDevice = createCloudToDevice;
//# sourceMappingURL=payload.js.map